import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';

export default class MastodonValidator extends BaseValidator {}
